import { APICallV3Get } from 'reactApp/api/APICall';

// Ручка для отправки письма с промо кодом ВК музыки
export class SendVkMusicPromocodeAPICall extends APICallV3Get {
    _method = 'billing/promo/vkmusic';
}
